import { defineStore } from "pinia";
import apiClient from "@/plugins/axios";

export const useVisitSession = defineStore("visitSession", {
  state: () => ({
    total: null,
  }),
  actions: {
    async track() {
      try {
        const { data } = await apiClient.post("/analytics/track-visit");
        if (typeof data?.total === "number") this.total = data.total;
        return this.total ?? 0;
      } catch {
        return this.total ?? 0;
      }
    },
    async get() {
      if (this.total != null) return this.total;
      try {
        const { data } = await apiClient.get("/analytics/visits");
        this.total = typeof data?.total === "number" ? data.total : 0;
        return this.total;
      } catch {
        return 0;
      }
    },
  },
});
